import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ptl-sg-button',
  templateUrl: './sg-button.component.html',
  styleUrls: ['./sg-button.component.scss'],
})
export class SgButtonComponent {
  @Input() type: 'flat' | 'stroked' | 'icon' = 'flat';
  @Input() color: 'primary' | 'potentially' | 'accent' | 'warn' = 'primary';
  @Input() disabled = false;
  @Input() matIconName: string;
  @Input() spriteSvgName: string;
  @Input() text: string;
  @Input() ariaLabel: string;

  @Output() clicked = new EventEmitter<void>();

  onClick(): void {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }
}
